/**
 * 予約の actions
 */
import * as api from '@/api'
import * as C from '@/consts'
import * as http from '@/libs/http'
// import * as time from '@/libs/time'

export default {
  /**
   * book ストアを初期化する
   *
   * @param {Context} context
   * @param {*} data 初期化データ
   */
  async init ({ commit, rootGetters }, data) {
    // ステーション名を取得する
    const orgCode = rootGetters['org/code']
    const resp = await api.getStation(orgCode, data.stationID, ['profile'])
    const station = {
      stationID: data.stationID,
      shopID: resp.data.shopID,
      name: resp.data.profile.name,
      address: resp.data.profile.address,
      map: resp.data.profile.map
    }

    // 初期化する
    commit('init', { station })

    // 予約可能期間を設定する
    if (data.allow) {
      commit('setAllow', data.allow)
    }

    // 予約期間を設定する
    if (data.schedule) {
      commit('setSchedule', data.schedule)
    }

    // 車両を設定する
    if (data.car) {
      commit('setChoosedCar', data.car)
    }
  },

  /**
   * 予約期間を設定する
   *
   * @param {Context} context
   * @param {Object} schedule 予約期間
   */
  async setSchedule ({ commit, dispatch }, schedule) {
    // 予約期間を設定する
    commit('setSchedule', schedule)

    // 期間情報を計算する
    return await dispatch('calcPeriod')
  },

  /**
   * 車両を設定する
   *
   * @param {Context} context
   * @param {Object} car 車両情報
   */
  async setCar ({ commit, dispatch }, car) {
    // 車両情報を設定する
    commit('setCar', car)

    // 期間情報を計算する
    const resp = await dispatch('calcPeriod')
    if (resp.status === http.OK) {
    } else {
      return false;
    }

    return true;
    //return await dispatch('calcPeriod')
  },

  /**
   * 期間情報を計算する
   *
   * @param {Context} context
   * @returns {Boolean} 障害が発生していなければ true を返す
   */
  async calcPeriod ({ state, getters, commit, rootGetters }) {
    // 計算する条件が揃っているか
    const schedule = state.schedule
    const car = state.car
    if (schedule.status !== C.INPUT_RESOLVED || !car) {
      return true
    }

    const uid = rootGetters['user/id']

    // api で期間を計算する
    const resp = await api.getPeriod(state.station.shopID, schedule.begin, schedule.end, car.id, state.reserveID, uid)
    if (resp.status === http.OK) {
      commit('setPeriod', resp.data)
    } else {
      alert(resp.data.reasons)
    }

    return resp
  },

  /**
   * 予約情報で book ストアを初期化する
   *
   * @param {Context} context
   * @param {*} data 初期化データ
   */
  async load ({ commit, rootGetters }, book) {
    // ステーション名を取得する
    const orgCode = rootGetters['org/code']
    const resp = await api.getStation(orgCode, book.stationID, ['profile'])
    const station = {
      stationID: book.stationID,
      shopID: resp.data.shopID,
      name: resp.data.profile.name,
      address: resp.data.profile.address,
      map: resp.data.profile.map
    }

    // 初期化する
    commit('init', { station })

    // 予約番号を設定する
    commit('setReserveID', book.reserveID)

    // 予約可能期間を設定する
    /*
    if (data.allow) {
      commit('setAllow', data.allow)
    }
    */

    // 予約期間を設定する
    commit('setSchedule', book.period)

    // 車両を設定する
    commit('setCar', book.car)

    // オプションを設定する
    commit('setOptions', book.options)

    // 免責補償を設定する
    commit('setInsurance', book.insurance)

    // 送迎を設定する
    commit('setPick', book.pick)

    // 配車を設定する
    commit('setDeli', book.deli)

    // 乗り捨てを設定する
    commit('setReturns', book.returnTo)

    // フライトを設定する
    // commit('setFlights', getSavedFlights(services.flights))

    // クーポンを設定する
    if (book.coupons) {
      commit('setCoupon', book.coupons[0])
    }

    // 料金情報をする
    if (book.charge) {
      commit('setCharge', book.charge)
    }
  },

  /**
   * 予約を実行する
   *
   * @param {Context} context
   */
  async register ({ state, getters, commit, rootGetters }) {
    const uid = rootGetters['user/id']
    const reserve = {
      // 予約ステーションID & 店舗ID
      station: state.station,

      // 予約期間
      period: state.period,

      // 車両
      car: state.car,

      // オプション
      options: getters.options,

      // 免責補償
      insurance: getters.insurance,

      // 送迎
      pick: getters.pick,

      // 配車
      deli: getters.deli,

      // 乗り捨て
      returns: getters.returns,

      // フライト
      flights: state.flights,

      // 乗車人数
      peoples: state.peoples,

      // クーポン
      coupons: state.coupon,

      // 備考
      note: state.note,

      // 料金
      charge: getters.charge,

      // 支払情報
      pay: state.pay
    }

    // api で予約を実行する
    let resp
    if (state.reserveID === 0) {
      // 新規登録
      resp = await api.newReserve(uid, reserve)
    } else {
      // 更新
      resp = await api.putReserve(uid, state.reserveID, reserve)
    }
    if (resp.status !== http.OK && resp.status !== http.Created) {
      return {
        ok: false,
        reasons: resp.data.reasons
      }
    }

    // 予約番号を保存する
    commit('setReserveID', resp.data.reserveID)

    return {
      ok: true,
      reasons: []
    }
  }
}
